<template>
	<div class="page-container has-action">
		<van-nav-bar title="商品详情" fixed left-arrow @click-left="goBack" :z-index="5000"></van-nav-bar>
		<div class="page product">
			<van-swipe class="top-swiper" @change="swipeChange">
				<van-swipe-item v-for="(n, i) of swipe.videos" :key="`swiper-slide-video-${i}`">
					<video-player :ref="'player-' + i" class="video-player" :playsinline="true" :options="n"></video-player>
				</van-swipe-item>
				<van-swipe-item v-for="(n, i) in swipe.images" :style="{ backgroundImage: `url(${n})` }" :key="`swiper-slide-img-${i}`"></van-swipe-item>
				<template #indicator>
					<div class="swiper-pagination-fraction">{{ swipe.current + 1 }}/{{ swipe.total }}</div>
				</template>
			</van-swipe>
			<!-- 改   已改！-->
			<div class="des bg-color-white px-20 py-10">
				<div class="des-title fy">{{ product.title }}</div>
				<div class="des-oldprice fy">市场价：{{ product.oldPriceStr }}元</div>
				<div class="des-points fs-18 fy">{{ product.scoreStr }}积分</div>
			</div>
			<!-- 源码 -->
			<!-- <div class="bg-color-white px-20 py-10">
                       <h1 class="fs-20  name ">{{product.title}}</h1>
                       <div class="color-purple mt-5 subtitle">原价：{{product.des}}</div>
                       <div class="fs-20 mt-5 color-purple price "><b>{{product.minPriceStr}}<span class="fs-14">积分{{product.minPrice > 0 ?'起':''}}</span></b>
                       </div>
             </div> -->
			<!-- 改 -->

			<!-- <van-cell class="mt-10 cell-kind" title="已选" is-link :value="kindName" @click="show = !show" /> -->

			<!-- 源码 -->
			<!-- 推荐产品 start-->
			<!-- <div class="p-10 bg-color-white push">
              <div class="van-hairline--surround px-20 py-10">
                <div class="title">
                  <span>为你推荐</span>
                </div>
                <div class="mt-10 flex-row flex-j-sb flex-wrap product-list">
                  <router-link
                    v-for="(n,i) of recommend"
                    :to="{name:'shop-product',params:{id:n.id}}"
                    class="product"
                    :key="`recommend-${i}`"
                  >
                    <img :src="n.coverImg" />
                    <div class="fs-16 mt-5">
                      <b>{{n.title}}</b>
                    </div>
                    <div class="fs-12 mt-5">{{n.des}}</div>
                    <div class="fs-18 mt-5 color-purple">
                      <b>
                        ¥{{n.minPriceStr}}
                        <span class="fs-12">元{{n.maxPrice > 0 ?'起':''}}</span>
                      </b>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>-->
			<!-- 推荐产品 end-->

			<!--  滚动导航 start -->
			<div class="caption">
				<span class="line"></span>
				<!-- <span class="txt">产品详情</span> -->
				<span class="txt fy">产品详情</span>
				<span class="line"></span>
			</div>
			<div class="detail">
				<img v-for="(n, i) of infoImg" :src="n" :key="`img-${i}`" alt />
				<img v-for="(n, i) of agrsImgsUrl" :src="n" :key="`argImg-${i}`" alt />
				<img v-for="(n, i) of qaImg" :src="n" :key="`qaImg-${i}`" alt />
			</div>
		</div>
		<div class="px-30 page-action">
			<van-button @click="show = !show" :disabled="skuData && skuData.stock_num < 1" type="warning" size="large" block class="mt-10 action">
				{{ skuData && skuData.stock_num < 1 ? '已售罄' : '立即兑换' }}
			</van-button>
		</div>
		<van-sku
			v-if="skuData"
			class="sku"
			v-model="show"
			:sku="skuData"
			:goods="defaultGoods"
			:hide-stock="false"
			:show-add-cart-btn="false"
			safe-area-inset-bottom
			@buy-clicked="buy"
			buy-text="立即兑换"
			stepper-title="兑换数量"
			price-tag="积分兑换"
		>
			<template #sku-header-price="props">
				<div class="van-sku__goods-price">
					<span class="van-sku__price-num">{{ parseInt(props.price) }} 积分</span>
				</div>
			</template>
			<template #sku-actions="props">
				<div class="van-sku-actions">
					<van-button :disabled="skuData.stock_num < 1" square size="large" type="danger" @click="props.skuEventBus.$emit('sku:buy')">积分兑换</van-button>
				</div>
			</template>
		</van-sku>
		<!--  -->
	</div>
</template>

<script>
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import { Button, Dialog, Popup, Cell, Sku, Swipe, SwipeItem } from 'vant';

import * as GoodsApi from '@/api/goods';
import session from '@/utils/session';

export default {
	name: 'detail',
	data: () => ({
		product: {},
		defaultGoods: {},
		recommend: [],
		skuData: null,
		form: {},
		show: false,
		swipe: {
			current: 0,
			total: 0,
			images: [],
			videos: []
		}
	}),
	beforeRouteEnter(to, from, next) {
		let p1 = GoodsApi.detail(to.params.id);
		let p2 = GoodsApi.getRecommend(to.params.id); // p2 可能不需要
		Promise.all([p1, p2])
			.then(data => {
				next(vm => vm.setData(data));
			})
			.catch(e => {});
	},
	beforeRouteUpdate(to, from, next) {
		let p1 = GoodsApi.detail(to.params.id);
		let p2 = GoodsApi.getRecommend(to.params.id); // p2 可能不需要
		Promise.all([p1, p2])
			.then(data => {
				this.setData(data);
				next();
			})
			.catch(e => {});
	},

	methods: {
		setData(data) {
			this.product = data[0].content;
			this.skuData = {
				tree: data[0].tree,
				list: data[0].list,
				price: this.product.score,
				stock_num: data[0].stock_num,
				collection_id: data[0].list[0].id
			};
			this.defaultGoods = {
				title: this.product.title,
				// 默认商品 sku 缩略图
				picture: this.product.coverImg
				//id: this.skuData.list[0].id,
			};
			this.recommend = data[1];
			if (this.product.imgsUrl) {
				this.swipe.images = this.product.imgsUrl.split(',');
			}
			if (this.product.videoUrl) {
				this.product.videoUrl.split(',').forEach((n, i) => {
					let options = {
						height: '300',

						autoplay: false,
						muted: false,
						sources: [
							{
								src: n
							}
						]
					};
					this.swipe.videos.push(options);
				});
			}
			this.swipe.total = this.swipe.images.length + this.swipe.videos.length;
		},

		buy(sku) {
			sku.goodsId = this.product.id;

			session.setJson('sku', sku);
			// 修改前
			// this.$router.replace({name: "shop-product-buy"});
			// 修改后
			this.$router.push({ name: 'shop-product-buy' });
		},

		goBack() {
			// this.$router.push({ name: 'home' });
			this.goableBack()
		},
		
		swipeChange(index) {
			if (this.swipe.current < this.swipe.videos.length) {
				this.$refs['player-' + this.swipe.current][0].player.pause();
			}
			this.swipe.current = index;
		}
	},

	computed: {
		kindName: () => {
			return '请选择规格';
		},
		infoImg: function() {
			if (this.product.infoImgsUrl) {
				return this.product.infoImgsUrl.split(',');
			} else {
				return [];
			}
		},
		agrsImgsUrl: function() {
			if (this.product.agrsImgsUrl) {
				return this.product.agrsImgsUrl.split(',');
			} else {
				return [];
			}
		},
		qaImg() {
			if (this.product.qaImgsUrl) {
				return this.product.qaImgsUrl.split(',');
			} else {
				return [];
			}
		}
	},
	components: {
		[Cell.name]: Cell,
		[Button.name]: Button,
		[Popup.name]: Popup,
		[Dialog.name]: Dialog,
		[Sku.name]: Sku,
		[Swipe.name]: Swipe,
		[SwipeItem.name]: SwipeItem,
		videoPlayer
	}
};
</script>

<style lang="less" scoped>
.van-swipe-item {
	width: 375px;
	height: 254px;
	line-height: 300px;
	background-size: 100% auto;
	background-repeat: no-repeat;
}

.swiper-pagination-fraction {
	position: absolute;
	bottom: 10px;
	left: auto;
	right: 30px;
	width: auto;
	background: rgba(0, 0, 0, 0.5);
	color: #fff;
	border-radius: 20px;
	padding: 0 10px;
	font-size: 12px;

	::v-deep .swiper-pagination-current {
		font-size: 14px;
	}
}
.video-player {
	position: relative;
	width: 100%;
	height: 100%;
	::v-deep .video-js {
		width: 100%;
		height: 100%;
		.vjs-big-play-button {
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
		.vjs-control-bar {
			background: transparent;
		}
	}
}

.cell-kind::after {
	left: 0;
}

.push {
	.title {
		font-size: 20px;
		color: #d6a147;
		text-align: center;
		font-weight: bold;

		span {
			display: inline-block;
			border-bottom: 3px solid #d6a147;
		}
	}

	.product-list {
		.product {
			width: 48%;

			img {
				width: 100%;
				height: auto;
			}
		}
	}
}

.detail ::v-deep {
	.van-tab {
		font-size: 14px;
		color: @gray-dark;
	}

	.van-tab--active {
		color: #d6a147;
	}

	.van-tabs__line {
		visibility: hidden;
	}
}

.notice img {
	width: 100%;
}

.sku {
	::v-deep .van-sku-actions .van-button--danger {
		background: #ff976a;
		border-color: #ff976a;
	}
}

.detail {
	img {
		width: 100%;
		max-width: 100vw;
		display: block;
	}
}

.page-action {
	background-color: transparent;
}

// 描述
.des {
	.des-title {
		font-size: 16px;
		font-weight: 700;
	}

	.des-oldprice {
		margin-top: 10px;
		font-size: 12px;
		color: #7b7a7a;
		text-decoration: line-through;
	}

	.des-points {
		margin-top: 10px;
		color: #fc6524;
	}
}

//产品详情
.caption {
	height: 53px;
	line-height: 53px;
	text-align: center;

	.line {
		width: 18px;
		display: inline-block;
		margin: 0 10px;
		border-top: 1px solid #000000;
	}

	.txt {
		color: #686868;
		vertical-align: -4px;
	}
}
</style>
